export default function useSearchQuery(search) {
  return new URLSearchParams(search);
}
